import { orderForm } from '@store/modules/order-form';
import { RouteConfig } from 'vue-router';
import { user } from '@store/modules/user';

/* eslint-disable @typescript-eslint/explicit-function-return-type */
const iraGeneralRoutes: RouteConfig[] = [
	{
		path: `/ira/rollover/checklist`,
		name: 'ira-rollover-checklist',
		component: () =>
			import(/* webpackChunkName: "ira-rollover-checklist" */ '@views/ira/general/ira-rollover-checklist.vue')
	},
	{
		path: `/ira/checkout`,
		name: 'ira-checkout-individual-details',
		beforeEnter: async (to, from, next) => {
			if (!orderForm.dataRetrieved) {
				await orderForm.getUserCheckoutDetailsData();
				if (orderForm.signUpCheckoutType !== 'IRA') {
					await orderForm.submitSignupCheckoutType('IRA');
				}
			}
			if (user.hasIraEntity) {
				await next({ name: 'ira-start', replace: true });
			} else {
				await next();
			}
		},
		component: () =>
			import(
				/* webpackChunkName: "ira-checkout-individual-details" */ '@views/ira/general/ira-checkout-individual-account-details.vue'
			)
	},
	{
		path: `/ira`,
		name: 'ira-landing',
		component: () => import(/* webpackChunkName: "ira-landing" */ '@views/ira/general/ira-landing.vue')
	}
];

export default iraGeneralRoutes;
